import { useState } from "react";
import { _formatFileSize, printDateAndTime } from "../../../../utils/common";
import CustomAlert from "../../../components/alert/customAlert";
import DefaultAvatar from "../../../components/avatar/defaultAvatar";

export const FolderDetails = ({ folder }) => {
  const [shareList, setShareList] = useState([]);
  const warning = {
    bg: "yellow-200",
    text: "text-primary-950",
    detail: "This folder is shared with everyone.",
  };
 

  return (
    <div className="flex flex-col gap-4">
      <div className="text-sm text-primary-950 border-b flex flex-col gap-2 pb-4">
        <div>
          <p className="text-primary-600 font-medium">
            {folder?.size ? "File Name" : "Folder Name"}
          </p>
          <p className="text-md capitalize">{folder?.name || "—"}</p>
        </div>
        {folder?.size && (
          <div>
            <p className="text-primary-600 font-medium">File Size</p>
            <p className="text-md capitalize">
              {_formatFileSize(folder?.size) || "—"}
            </p>
          </div>
        )}

        {folder?.access && (
          <div>
            <p className="text-primary-600 font-medium">Access Type</p>
            <p className="text-md capitalize">{folder?.access || "—"}</p>
          </div>
        )}

        {folder?.folder_access && (
          <div>
            <p className="text-primary-600 font-medium">Folder Access</p>
            <p className="text-md capitalize">{folder?.folder_access || "—"}</p>
          </div>
        )}

        {folder?.created_by && (
          <div>
            <p className="text-primary-600 font-medium">Owner</p>
            <p className="text-md capitalize">
              {folder?.created_by?.label || "—"}
            </p>
          </div>
        )}

        {folder?.created_at && (
          <div>
            <p className="text-primary-600 font-medium">Created On</p>
            <p className="text-md">
              {printDateAndTime(folder?.created_at, true)}
            </p>
          </div>
        )}

        {folder?.updated_at && (
          <div>
            <p className="text-primary-600 font-medium">Last Modified</p>
            <p className="text-md">
              {printDateAndTime(folder?.updated_at, true)}
            </p>
          </div>
        )}

        {folder?.access && (
          <div>
            <p className="text-primary-600 font-medium">No. of Document</p>
            <p className="text-md capitalize">
              {folder?.documents_count || "0"}
            </p>
          </div>
        )}
      </div>
      {folder?.created_by && (
        <div className="text-sm text-primary-950 flex flex-col gap-2 pb-4">
          <div>
            <p className="text-primary-600 font-medium">Manage Access</p>
            <div className="flex flex-row gap-2 items-center">
              <div className="w-10 h-10 rounded-full bg-primary-50 flex-center">
                <DefaultAvatar image={folder?.created_by?.profile_image} />
              </div>
              <span className="flex flex-col ">
                <p className="capitalize">{folder?.created_by?.label || "—"}</p>
                <p className="capitalize">{folder?.created_by?.email || "—"}</p>
              </span>
            </div>
          </div>
        </div>
      )}

      {folder?.folderUsers &&folder?.folderUsers.length>0 && (
        <div className="flex flex-col gap-2">
          {folder.folderUsers.length > 0 ? (
            <>
              <h2 className="text-primary-600 font-medium">Shared With:</h2>
              <div className="flex flex-row gap-1 flex-wrap">
                {folder.folderUsers.map((item) => (
                  <span
                    key={item.uuid}
                    className="py-2 px-4 bg-primary-50 rounded-md"
                  >
                    {item?.user?.name} ({item?.user?.email})
                  </span>
                ))}
              </div>
            </>
          ) : (
            <div className="border-t pt-4">
              <CustomAlert alert={warning} />
            </div>
          )}
        </div>
      )}
    </div>
  );
};
